import {
  Arbeitsbereich,
  Mitarbeiter,
} from '@/domain/navigation/benachrichtigungen/types/Benachrichtungen';
import dayjs from 'dayjs';

export class FehlendeArbeitszeiten {
  constructor({
    id,
    status,
    datum,
    mitarbeiter,
    arbeitsbereich,
  }: {
    id: string;
    status: string;
    datum: dayjs.Dayjs;
    mitarbeiter: Mitarbeiter;
    arbeitsbereich: Arbeitsbereich;
  }) {
    this.id = id;
    this.status = status;
    this.datum = datum;
    this.mitarbeiter = mitarbeiter;
    this.arbeitsbereich = arbeitsbereich;
  }
  id: string;
  status: string;
  datum: dayjs.Dayjs;
  mitarbeiter: Mitarbeiter;
  arbeitsbereich: Arbeitsbereich;
}
